import { gql } from '@apollo/client';

export * from './secureUploadInit.mutation.generated';

export const REPO_UPLOAD_INIT = gql`
  mutation repoUploadInit(
    $softwareEscrowId: ID!
    $numParts: Int!
    $filename: String!
    $repoName: String
    $assetId: ID
  ) {
    repoUploadInit(
      input: {
        softwareEscrowId: $softwareEscrowId
        numParts: $numParts
        filename: $filename
        repoName: $repoName
        assetId: $assetId
      }
    ) {
      success
      errors
      uploadId
      uploadUrls
    }
  }
`;
